import React from 'react';
import Icon from './Icon';

const Footer: React.FC = () => {
  const socialLinks = [
    { name: 'Instagram', href: 'https://instagram.com/enfitah', icon: 'Instagram' as const },
    { name: 'Youtube', href: 'https://youtube.com/@enfitah', icon: 'Youtube' as const },
    { name: 'Facebook', href: 'https://www.facebook.com/EnfitahThemes', icon: 'Facebook' as const },
  ];

  return (
    <footer className="bg-[var(--color-input-bg)] mt-24 py-5 border-t border-[var(--color-border)]">
      <div className="px-4 sm:px-6 lg:px-[70px] max-w-screen-xl mx-auto">
        <div className="w-full flex flex-col sm:flex-row items-center sm:justify-between gap-6">
          {/* Copyright Info */}
          <div>
            <p className="text-sm text-[var(--color-text-body)]">
              إنفتاح © | جميع الحقوق محفوظة.
            </p>
          </div>
          {/* Social Icons */}
          <div className="flex items-center gap-4">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[var(--color-text-body)] hover:text-[var(--color-primary)] transition-colors duration-200"
                aria-label={`Follow us on ${link.name}`}
              >
                <Icon name={link.icon} className="w-4 h-4" />
              </a>
            ))}
            {/* X Icon */}
            <a
              href="http://x.com/enfitah"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--color-text-body)] hover:text-[var(--color-primary)] transition-colors duration-200"
              aria-label="Follow us on X"
            >
              <svg
                className="w-4 h-4"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;